import {getHostApi} from "../../../../utils";
import {getUserId} from "../../MonCompteAction";

export function baseUrlEmbrodery(idCaddies: string, idCommande: number, surfaceId: number, emplacementId: number, fileRegisteredId: number):string {
  return `${getHostApi()}/customers/${getUserId()}/orders/${idCommande}/items/${idCaddies}/surfaces/${surfaceId}/locations/${emplacementId}/images-bat-auto/${fileRegisteredId}/`;
}

export function fetchDataFilsExist(idCaddies: string, baseUrl: string, fileRegisteredCreationId: string, surfaceEmplacementId: number, traitementContour: string, galerieFichierVariableId: number):any {
  const data = {
    "routeFetchFils":`${baseUrl}embroidery/exist?galerieFichierVariableId=${galerieFichierVariableId}`,
    "tiff": `${fileRegisteredCreationId}-${surfaceEmplacementId}.tiff`,
    "traitementContour": `${traitementContour}`
  }
  return data;
}